var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { createStyles } from 'antd-style';
export default createStyles(function (_ref) {
  var _token$customRadio;
  var css = _ref.css,
    token = _ref.token,
    prefixCls = _ref.prefixCls;
  return {
    aelfDesignRadio: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      &.", "-radio-wrapper .", "-radio-inner::after {\n        background-color: ", ";\n      }\n      &.", "-radio-wrapper .", "-radio-checked .", "-radio-inner {\n        background-color: ", ";\n      }\n    "])), prefixCls, prefixCls, (_token$customRadio = token.customRadio) === null || _token$customRadio === void 0 ? void 0 : _token$customRadio.dotColor, prefixCls, prefixCls, prefixCls, token.colorPrimary)
  };
});